export default "__VITE_ASSET__014843c6__"